export const PHONE_FOR_CALL = '8 (920) 324-03-93';
export const PHONE_FOR_CALL_SECOND = '8 (900) 573-12-26';
export const PROVIDER_NAME_ENG = 'OK-TELECOM';
export const PROVIDER_NAME_RU = 'ОК-ТЕЛЕКОМ';
export const PROVIDER_SUPPORT_EMAIL = '';
